import { createBrowserRouter } from "react-router-dom"
import MainLayout from "../layout/MainLayout"
import { Appointments } from "../pages/Booking/Booking"
import CashRegister from "../pages/CashRegister"
import { Clients } from "../pages/Clients/Clients"
import { Collaborateurs } from "../pages/Collaborateurs/Collaborateurs"
import { Dashboard } from "../pages/Dashboard/Dashboard"
import { Historic } from "../pages/Historic/Historic"
import { ListServices } from "../pages/ListServices/ListServices"
import { Promotions } from "../pages/Promotions/Promotions"
import { Schedules } from "../pages/Schedules/Schedules"
import { ShopSettings } from "../pages/ShopSettings/ShopSettings"
import { Unavailability } from "../pages/Unavailability/Unavailability"

export const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "/bookings",
        element: <Appointments />,
      },
      {
        path: "/schedules",
        element: <Schedules />,
      },
      {
        path: "/historic",
        element: <Historic />,
      },
      {
        path: "/listServices",
        element: <ListServices />,
      },
      {
        path: "/promotions",
        element: <Promotions />,
      },
      {
        path: "/clients",
        element: <Clients />,
      },
      {
        path: "/collaborateurs",
        element: <Collaborateurs />,
      },
      {
        path: "/shop-settings",
        element: <ShopSettings />,
      },
      {
        path: "/unavailability",
        element: <Unavailability />,
      },
      {
        path: "/cash-register",
        element: <CashRegister />,
      },
    ],
  },
])
